import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQueryMatchesOnMobile, useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { useState, useEffect, useCallback } from 'react';
import { Box, Carousel, CarouselVariant, Column, FeedbackMessage, FeedbackMessageVariant, IconName, IconSize, Link, SliderNavColor, SliderNavVariant, } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { useTranslation } from 'react-i18next';
import { ProductTileVertical } from '../../product-tile/vertical/ProductTileVertical';
import { MIN_SCREEN_WIDTH_TABLET, MIN_SCREEN_WIDTH_DESKTOP, MIN_SCREEN_WIDTH_DESKTOP_LARGE, } from '../../../constants/ScreenWidthConstants';
import { SLIDE_SPACING, SLIDES_AMOUNT_DESKTOP, SLIDES_AMOUNT_DESKTOP_LARGE } from '../../../constants/SliderConstants';
import { isInStoreOnly, isProductOutOfStock, isClickAndCollectOnly, isProductWithColorOutOfStock, getProductDetailUrl, } from '../../../util/ProductUtil';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
export const CompareCarousel = ({ comparisonProducts, onCloseClick, deliveryPromiseExplanations, addToBasket, getDeliveryPromise, setSwiperInstance, compareItemSelectSize, }) => {
    const { root, feature_toggles: { lowest_price_all }, } = useAemConfig();
    const isMobile = useMediaQueryMatchesOnMobile();
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const [compareCarouselSwiper, setCompareCarouselSwiper] = useState(null);
    const setSwiper = (swiper) => {
        setCompareCarouselSwiper(swiper);
        setSwiperInstance(swiper);
    };
    useEffect(() => {
        if (compareCarouselSwiper !== null) {
            compareCarouselSwiper.update();
        }
    }, [comparisonProducts, compareCarouselSwiper]);
    const compareCarouselConfig = {
        variant: CarouselVariant.PRODUCT_TILE_NORMAL,
        arrowsConfig: {
            color: SliderNavColor.BASE,
            variant: SliderNavVariant.CIRCLE,
        },
        showPagination: false,
        fullWidth: true,
        configurationOverrides: {
            preventClicks: true,
            slidesPerView: 'auto',
            spaceBetween: SLIDE_SPACING.MOBILE,
            watchOverflow: true,
            getSwiper: setSwiper,
            breakpoints: {
                [MIN_SCREEN_WIDTH_TABLET]: {
                    slidesPerView: 'auto',
                    spaceBetween: SLIDE_SPACING.TABLET,
                },
                [MIN_SCREEN_WIDTH_DESKTOP]: {
                    slidesPerView: SLIDES_AMOUNT_DESKTOP,
                    spaceBetween: SLIDE_SPACING.DESKTOP,
                },
                [MIN_SCREEN_WIDTH_DESKTOP_LARGE]: {
                    slidesPerView: SLIDES_AMOUNT_DESKTOP_LARGE,
                    spaceBetween: SLIDE_SPACING.DESKTOP,
                },
            },
        },
    };
    const compareSlide = useCallback((product) => {
        const productOutOfStock = isProductOutOfStock(product);
        const colorOutOfStock = isProductWithColorOutOfStock(product);
        return (_jsxs(Column, { gutter: false, grid: 4, desktop: 3, tablet: 4, tabletSmall: 4, children: [_jsx(ProductTileVertical, { product: product, initialActiveSku: product.selectedSku, showSwatchesOnHover: false, iconName: IconName.CLOSE, onIconClick: onCloseClick, getDeliveryPromise: getDeliveryPromise, handleSizeSelect: compareItemSelectSize, deliveryPromiseExplanations: deliveryPromiseExplanations, format: "extensive", productTileExtensiveVariant: isDesktop ? null : 'simple', addToBasket: addToBasket, showProductOutOfStockOverlay: true, showColorOutOfStockOverlay: true, clickAndCollectOnly: isDesktop && isClickAndCollectOnly(product), inStoreOnly: isDesktop && isInStoreOnly(product), dropdownProps: { appendToBody: true }, enablePriceReference: lowest_price_all }), !isMobile && (productOutOfStock || colorOutOfStock) && (_jsx(Box, { desktop: { spacing: { marginTop: productOutOfStock ? 2.5 : 0 } }, children: _jsx(FeedbackMessage, { variant: FeedbackMessageVariant.INFO, text: productOutOfStock ? (t('product.out.of.stock.feedback')) : (_jsxs(_Fragment, { children: [t('product.color.out.of.stock.feedback.part1'), ' ', _jsx(Link, { href: getProductDetailUrl(product, root), children: t('product.color.out.of.stock.feedback.part2') })] })), iconSize: IconSize.MAJOR }) }))] }, `${product.productCode}${product.colourId.toString()}`));
    }, [comparisonProducts, addToBasket, isDesktop]);
    return _jsx(Carousel, Object.assign({}, compareCarouselConfig, { children: comparisonProducts.map(compareSlide) }));
};
